export default "__VITE_ASSET__DcrhRtan__"